import React from 'react';
import { Link } from 'react-router-dom';
import { PATH } from '../../../constants';

const LinksBoxWithName = ({ links, isFetching = false, category = null, boxName }) => {
    if (isFetching || !links) {
        return null;
    }

    const resolvedLinks = links.map((item) => {
        if (item?.entries) {
            return null;
        }

        const link = category
            ? `${PATH.helpAndSupport}/${category}/${item.id}`
            : `${PATH.helpAndSupport}/${item.id}`;

        return (
            <li key={item.id} className="links-box__item">
                <Link
                    className="link"
                    to={link}
                    title={item.name}
                    state={{ categoryName: item.name }}
                >
                    {item.name}
                </Link>
            </li>
        );
    });

    return (
        <div className="links-box">
            {resolvedLinks && <h2 className="links-box__name">{boxName}</h2>}
            <ul>
                {resolvedLinks}
            </ul>
        </div>
    );
};

export default LinksBoxWithName;
